module.exports = __webpack_public_path__ + "static/img/cocina_08.183f3029.jpeg";